import {useStompClient} from "react-stomp-hooks";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions} from "../../store/sliceWebsocket";
import {FC} from "react";
import {fetchRefreshToken} from "../../fetch/AuthRequest";

type SendingMessagesProps = {
    init?: () => void
}
const SendingMessages: FC<SendingMessagesProps> = ({init})  => {
    const stompClient = useStompClient();
    const dispatch = useDispatch<AppDispatch>();

    const sendMessage = (body: string, destination: string) => {
        if (stompClient) {
            // fetchRefreshToken()
                //Send Message
                if (body.length === 0) {
                    stompClient.publish({
                        destination: destination,
                    });
                } else {
                    stompClient.publish({
                        destination: destination,
                        body: body,
                    });
                }
        } else {
            //Handle error
        }
    };

    dispatch(actions.setFunc({send: sendMessage}))
    if (init) {
        init()
    }
    return <div style={{visibility: "hidden"}}></div>

}

export default SendingMessages
